import { wechatAccountWsClient, wechatChatWsClient } from "../request";
import {
  ChannelTypeEnum,
  ChatType,
  WS_REQUEST_MESSAGE_TYPE,
  ServiceType,
} from "../types";
type WechatContactType = any;
/**
 * 打开客户端
 */
const sendOpenClientCommand = (params: {
  team_id: string;
  user_id: string;
  client_id?: number;
  ip?: string;
  request_key?: string;
}) => {
  const { team_id, user_id, client_id, ip, request_key } = params;
  return wechatAccountWsClient.sendMessage({
    message_type: WS_REQUEST_MESSAGE_TYPE.OPEN,
    channel_type: ChannelTypeEnum.Wechat,
    service_type: ServiceType.WECHAT_PC,
    ip,
    client_id,
    request_key,
    user_id,
    data: {
      teamId: team_id,
    },
  });
};

/**
 *
 * 验证登录请求
 */
export type SendVerifyVerificationParams = {
  login_verify_code: string; // 手机端的验证码
  login_qrcode_key: string;
  request_key: string;
};
const sendVerifyVerificationCommand = (
  from_user_id: string,
  serviceType: ServiceType,
  data: SendVerifyVerificationParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  return wechatAccountWsClient.sendMessage({
    channel_type: ChannelTypeEnum.Wechat,
    user_id: from_user_id,
    message_type: WS_REQUEST_MESSAGE_TYPE.VERIFY_VERIFICATION_CODE,
    data,
    service_type: serviceType,
    request_key,
  });
};

/**
 * 发送文本消息
 */
export type WechatSendTextParams = {
  content: string;
  to_id: string;
  chat_type: WechatContactType;
  request_key: string;
};
const sendTextCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendTextParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_TEXT,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};

/**
 * 发送文本混合消息
 */
export type WechatSendTextMixedParams = {
  content: {
    subtype: number;
    text: string;
  }[];
  to_id: string;
  chat_type: WechatContactType;
  request_key: string;
};
const sendTextMixedCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendTextMixedParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_TEXT_MIXED,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};

export type WechatSendImageParams = {
  to_id: string;
  chat_type: WechatContactType;
  request_key: string;
  path: string;
};
const sendImageCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendImageParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_IMAGE,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};
// 发送视频
export type WechatSendVideoParams = {
  to_id: string;
  chat_type: WechatContactType;
  request_key: string;
  path: string;
};
const sendVideoCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendVideoParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_VIDEO,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};

// 发送视频号
export type WechatSendVideoNumParams = {
  to_id: string;
  chat_type: WechatContactType;
  username: string;
  channel_name: string;
  channel_url: string;
  head_img_url: string;
  thumb_url: string;
  encode_data: string;
  request_key: string;
};
const sendVideoNumCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendVideoNumParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_VIDEO_NUM,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};

// 发送文件
export type WechatSendFileParams = {
  to_id: string;
  chat_type: WechatContactType;
  request_key: string;
  path: string;
};
const sendFileCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendFileParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_FILE,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};
// 发送gif

export type WechatSendGifParams = {
  to_id: string;
  chat_type: WechatContactType;
  request_key: string;
  path: string;
};
const sendGifCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendGifParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_GIF,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};
// 发送链接消息
export type WechatSendLinkParams = {
  to_id: string;
  chat_type: WechatContactType;
  desc: string;
  request_key: string;
  thumburl: string;
  title: string;
  url: string;
};
const sendLinkCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendLinkParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_LINK,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};

export type WechatSendMiniProgramParams = {
  request_key: string;
  appid: string;
  to_id: string;
  chat_type: WechatContactType;
  cover_file_aeskey: string;
  cover_file_id: string;
  cover_file_md5: string;
  cover_file_size: number;
  desc: string;
  pagepath: string;
  thumburl: string;
  username: string;
};
const sendMiniProgramCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendMiniProgramParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_MINI_PROGRAM,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};

// 发送好友卡片
export type WechatSendBusinessCardParams = {
  shared_id: string;
  to_id: string;
  chat_type: WechatContactType;
  request_key: string;
};
const sendBusinessCardCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendBusinessCardParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_BUSINESS_CARD,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};

// 发送语音
export type WechatSendVoiceParams = {
  to_id: string;
  chat_type: WechatContactType;
  duration_time: number;
  file_aeskey: string;
  file_id: string;
  file_size: number;
  request_key: string;
};
const sendVoiceCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: WechatSendVoiceParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.SEND_VOICE,
    channel_type: ChannelTypeEnum.Wechat,
    data,
    user_id: from_user_id,
    service_type,
    request_key,
  };

  return wechatChatWsClient.sendMessage(params);
};

// 撤回消息
type SendRevocationMessageParams = {
  msg_unique_identifier: string;
  request_key: string;
  msg_server_id: string;
  to_id: string;
  chat_type: ChatType;
  sender_id: string;
};
const sendRevocationMessageCommand = (
  from_user_id: string,
  service_type: ServiceType,
  data: SendRevocationMessageParams
) => {
  const request_key = data.request_key;
  Reflect.deleteProperty(data, "request_key");
  const params = {
    message_type: WS_REQUEST_MESSAGE_TYPE.REVOCATION_MESSAGE,
    channel_type: ChannelTypeEnum.Wechat,
    service_type,
    data,
    user_id: from_user_id,
    request_key,
  };
  return wechatChatWsClient.sendMessage(params);
};

const WechatCommand = {
  sendOpenClientCommand,
  sendVerifyVerificationCommand,
  sendTextCommand,
  sendTextMixedCommand,
  sendImageCommand,
  sendVideoCommand,
  sendVideoNumCommand,
  sendFileCommand,
  sendGifCommand,
  sendLinkCommand,
  sendMiniProgramCommand,
  sendBusinessCardCommand,
  sendVoiceCommand,
  sendRevocationMessageCommand,
};
export default WechatCommand;
